/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

export function TimeRange() {
  return <h1>Time Range</h1>;
}

export default TimeRange;
